import { render, staticRenderFns } from "./RelativeTime.vue?vue&type=template&id=b0a11e40&"
import script from "./RelativeTime.vue?vue&type=script&lang=ts&"
export * from "./RelativeTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports